var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-home vertical-layout" },
    [
      _c("HomeVideo"),
      _vm._v(" "),
      _vm.isMobile && _vm.open
        ? _c("TopMenuPopup", {
            on: {
              click: function($event) {
                return _vm.closeModalMenu()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("HeaderMobile", {
            on: {
              click: function($event) {
                return _vm.openModalMenu()
              }
            }
          })
        : _c("Header"),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "info-area" },
            [
              _vm.isMobile
                ? _c("InfoAreaMobile", { attrs: { id: "infoAreaId" } })
                : _c("InfoArea", { attrs: { id: "infoAreaId" } })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "products-search-area" }, [
          _c("div", { staticClass: "gradient-tier" }),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                {
                  staticClass: "products-area",
                  attrs: { id: "productAreaId" }
                },
                [_vm._t("products")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-area", attrs: { id: "contentAreaId" } },
                [_vm._t("content")],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-footer" },
          [_vm._t("content-footer")],
          2
        )
      ]),
      _vm._v(" "),
      _c("footer", [_c("Footer")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b764e09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b764e09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/HomeLayout.vue
// module id = null
// module chunks = 